import { LineChartData } from "Components/Charts/Line/Line";
import { useSelector } from "react-redux";
import {
  selectDashboardInspectionSubmissionWeekly,
  selectDashboardInspectionSubmissionWeeklyLoading,
} from "Redux/Dashboard/slice";

export const useDashboard = () => {
  const inspectionSubmission = useSelector(
    selectDashboardInspectionSubmissionWeekly,
  );
  const loading = useSelector(selectDashboardInspectionSubmissionWeeklyLoading);

  const data: LineChartData[] = [
    {
      title: "This week",
      data: inspectionSubmission?.current_week?.map(
        (inspection) => inspection.count,
      ),
      itemColor: "rgba(223, 98, 174, 1)",
      areaColor: ["rgba(223, 98, 174, 1)", "rgba(223, 98, 174, 0)"],
    },
    {
      title: "Last week",
      itemColor: "rgba(0, 125, 242, 1)",
      areaColor: ["rgba(0, 125, 242, 0.5)", "rgba(0, 125, 242, 0)"],
      data:
        inspectionSubmission?.previous_week?.map(
          (inspection) => inspection.count,
        ) || [],
    },
  ];

  return { data, loading };
};
